export const gridColumns = [
  {
    field: 'id',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'id',
    filter: 'number'
  },
  {
    field: 'user',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'created by',
    filter: 'text',
  },
  {
    field: 'subject',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'subject',
    filter: 'text',
  },
  {
    field: 'ticket_category',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'category',
    filter: 'text',
  },
  {
    field: 'created_at',
    filter: 'text',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'createdAt',
  },
  {
    field: 'status',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'status',
    filter: 'text',
  },
  {
    field: 'jira_status_name',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'Jira Status',
    filter: 'text',
  },
  {
    field: 'priority',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'Priorität',
    filter: 'text',
  },
  {
    field: 'art',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'type',
    filter: 'text',
  },
  {
    field: 'assigned_user_name',
    filterable: true,
    width: 150,
    hidden: false,
    title: 'Zugewiesener Benutzer',
    filter: 'text',
  },
];
